import React, { useState, useEffect } from "react";
import { Button } from "flowbite-react";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingOverlay from "../LoadingOverlay";
import ConfirmDialog from "../ConfirmDialog";

function MaterialGroupModal({ dataSet, onClose, refreshData }) {
  const [groupId, setGroupId] = useState("");
  const [groupName, setGroupName] = useState("");
  const [groupCode, setGroupCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);

  useEffect(() => {
    if (dataSet) {
      setGroupName(dataSet.group_name);
      setGroupId(dataSet.group_id);
      setGroupCode(dataSet.group_code);
    }
  }, [dataSet]);

  const updateGroup = async (e) => {
    try {
      setIsLoading(true);
      const response = await axios.patch(
        `https://eps.elkomprintama.com/patch/api/store/store/material_group`,
        {
          group_name: groupName.toLocaleUpperCase(),
          group_code: groupCode.toLocaleUpperCase(),
          group_id: groupId,
        }
      );
      if (response.status === 200) {
        // Access the 'msg' property from the response data
        toast.success(response.data.msg); // This will display the success message
        setGroupId("");
        setGroupName("");
        setGroupCode("");
        onClose();
        refreshData();
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleGroupNameChange = (e) => {
    setGroupName(e.target.value);
  };

  const handleGroupCodeChange = (e) => {
    setGroupCode(e.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!groupName) {
      toast.warning("Please fill in all required fields");
      return;
    }
    setUploadPending(true);
    setShowConfirm(true);
  };

  return (
    <div className="relative max-w-3xl w-full bg-gray-100 p-6 rounded-lg shadow-md">
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="flex gap-4">
          <div className="w-24">
            <label
              htmlFor="group_number"
              className="block text-sm font-medium text-gray-700 uppercase"
            >
              Group ID
            </label>
            <input
              id="group_number"
              name="group_number"
              placeholder="1"
              value={groupId}
              disabled
              className="mt-1 block w-full uppercase text-gray-400 border border-green-400 bg-white rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-green-500"
            />
          </div>

          <div className="flex-1">
            <label
              htmlFor="group_name"
              className="block text-sm font-medium text-gray-700 uppercase"
            >
              Group Name
            </label>
            <input
              id="group_name"
              name="group_name"
              type="text"
              placeholder="Group Name"
              value={groupName}
              onChange={handleGroupNameChange}
              className="mt-1 block w-full uppercase border border-green-400 bg-white rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-green-500"
            />
          </div>
          <div className="w-24">
            <label
              htmlFor="group_number"
              className="block text-sm font-medium text-gray-700 uppercase"
            >
              Group Code
            </label>
            <input
              id="group_code"
              name="group_code"
              placeholder="Group Code"
              value={groupCode}
              onChange={handleGroupCodeChange}
              className="mt-1 block w-full uppercase border border-green-400 bg-white rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-green-500"
            />
          </div>
        </div>

        <div className="w-full space-y-3">
          <Button fullSized type="submit" color="blue">
            Update
          </Button>
          <Button
            fullSized
            onClick={onClose}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Close
          </Button>
        </div>
        {isLoading && <LoadingOverlay message="loading..." />}
        {showConfirm && uploadPending && (
          <ConfirmDialog
            message="Are you sure you want to insert the data?"
            onConfirm={() => {
              setShowConfirm(false);
              updateGroup();
            }}
            onCancel={() => {
              setShowConfirm(false);
              setUploadPending(false);
            }}
          />
        )}
      </form>
    </div>
  );
}

export default MaterialGroupModal;
